module.exports = __webpack_public_path__ + "static/media/book1.20e9946b.svg";